export function companyPerformancePartnersEnabled(
  company?: {
    performancePartnersEnabled?: boolean;
  } | null
) {
  return company?.performancePartnersEnabled === true;
}
